import "react-datepicker/dist/react-datepicker.css";
import FormInput from "./FormInput";
import {
  CustomRecurrenceScheduleType,
  ExtendedRecurrenceScheduleType,
  Week,
} from "../utils/CreateOrderContextProvider";
import { RecurrenceScheduleType } from "@api/graphql/generated/generated-types";
import WeekdaySelector from "./WeekdaySelector";
import MonthlyScheduleSelector from "./MonthlyScheduleSelector";
import EveryNWeeksIntervalInput from "./EveryNWeeksIntervalInput";
import { Control, FieldErrors, FieldValues } from "react-hook-form";

type Props = {
  control: Control<FieldValues, any>;
  errors: FieldErrors<FieldValues>;
  recurrenceSchedule: ExtendedRecurrenceScheduleType;
  selectedDaysWeek: Week;
  setSelectedDaysWeek: any;
  selectedCustomDaysOfTheMonth: any[];
  setSelectedCustomDaysOfTheMonth: (days: any[]) => void;
  everyNWeeksInterval: number;
  setEveryNWeeksInterval: (weeks: number) => void;
};

function ScheduleTypeSelector({
  control,
  errors,
  recurrenceSchedule,
  selectedDaysWeek,
  setSelectedDaysWeek,
  selectedCustomDaysOfTheMonth,
  setSelectedCustomDaysOfTheMonth,
  everyNWeeksInterval,
  setEveryNWeeksInterval,
}: Props) {
  return (
    <>
      {recurrenceSchedule === CustomRecurrenceScheduleType.DoesNotRepeat && (
        <FormInput
          name="shipments.0.shipmentDate"
          label="Shipment Date"
          control={control}
          errors={errors}
          isDatePicker={true}
        />
      )}
      {recurrenceSchedule === RecurrenceScheduleType.CustomDaysOfTheWeek && (
        <WeekdaySelector
          selectedDayWeek={selectedDaysWeek}
          setSelectedDayWeek={setSelectedDaysWeek}
          multiple={true}
        />
      )}
      {recurrenceSchedule === RecurrenceScheduleType.CustomDaysOfTheMonth && (
        <MonthlyScheduleSelector
          selectedCustomDaysOfTheMonth={selectedCustomDaysOfTheMonth}
          setSelectedCustomDaysOfTheMonth={setSelectedCustomDaysOfTheMonth}
        />
      )}
      {recurrenceSchedule === RecurrenceScheduleType.EveryNWeeks && (
        <>
          <EveryNWeeksIntervalInput
            intervalWeeks={everyNWeeksInterval}
            setIntervalWeeks={setEveryNWeeksInterval}
          />
          <WeekdaySelector
            selectedDayWeek={selectedDaysWeek}
            setSelectedDayWeek={setSelectedDaysWeek}
            multiple={true}
          />
        </>
      )}
      {recurrenceSchedule === RecurrenceScheduleType.MonthlyOnFirst && (
        <WeekdaySelector
          selectedDayWeek={selectedDaysWeek}
          setSelectedDayWeek={setSelectedDaysWeek}
          multiple={true}
        />
      )}
      {recurrenceSchedule === RecurrenceScheduleType.MonthlyOnSecond && (
        <WeekdaySelector
          selectedDayWeek={selectedDaysWeek}
          setSelectedDayWeek={setSelectedDaysWeek}
          multiple={true}
        />
      )}
      {recurrenceSchedule === RecurrenceScheduleType.MonthlyOnThird && (
        <WeekdaySelector
          selectedDayWeek={selectedDaysWeek}
          setSelectedDayWeek={setSelectedDaysWeek}
          multiple={true}
        />
      )}
      {recurrenceSchedule === RecurrenceScheduleType.MonthlyOnFourth && (
        <WeekdaySelector
          selectedDayWeek={selectedDaysWeek}
          setSelectedDayWeek={setSelectedDaysWeek}
          multiple={true}
        />
      )}
      {recurrenceSchedule === RecurrenceScheduleType.MonthlyOnLast && (
        <WeekdaySelector
          selectedDayWeek={selectedDaysWeek}
          setSelectedDayWeek={setSelectedDaysWeek}
          multiple={true}
        />
      )}
      {recurrenceSchedule === RecurrenceScheduleType.MonthlyOnFifthWeek && (
        <WeekdaySelector
          selectedDayWeek={selectedDaysWeek}
          setSelectedDayWeek={setSelectedDaysWeek}
          multiple={true}
        />
      )}
    </>
  );
}

export default ScheduleTypeSelector;
